import { useGetApiProjectsByProjectIdEtlSourcesQuery } from '@/model/etlSource/api.generated';
import { getSourceItemsFromDraft } from '@/model/etlSource/etlSource.model';
import { skipToken } from '@reduxjs/toolkit/query/react';

export const useEtlSourceCount = (projectId: string | undefined): number | undefined => {
  const { data } = useGetApiProjectsByProjectIdEtlSourcesQuery(
    projectId ? { projectId } : skipToken,
  );

  return getSourceItemsFromDraft(data)?.length;
};
